import actions from '@/core/store/partes-envolvidas/actions'
import mutations from '@/core/store/partes-envolvidas/mutations'
import state from '@/core/store/partes-envolvidas/state'

export default {
	actions,
	mutations,
	state,
}
